import { createReducer } from '@reduxjs/toolkit'
import { forEach, get, isUndefined } from 'lodash'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  confirmed: true,
  open: true,
  draft: true,
  pending: true,
  expired: true,
  meetingsBooked: true,
  meetingsOpen: true,
  virtual: '',
}

const setIfDefined = (state, key, newValue) => {
  if (isUndefined(state[key])) {
    return state
  }
  return {
    ...state,
    [key]: newValue,
  }
}

export default createReducer(INITIAL_STATE, {
  '@@INIT': (state) => {
    forEach(INITIAL_STATE, (val, key) => {
      state[key] = get(state, key, val)
    })
  },
  [types.VISIT_TYPE_FILTER_HIDE]: (state, action) => setIfDefined(state, action.payload, false),
  [types.VISIT_TYPE_FILTER_SHOW]: (state, action) => setIfDefined(state, action.payload, true),
  [types.VISIT_TYPE_FILTER_CHANGE]: (state, action) => setIfDefined(state, action.payload.name, action.payload.value),
})
